//Packages
import React, { useEffect, useState } from "react";
import axios from "axios";
//Components
import { useParams } from "react-router-dom";
//Material UI Components
import { Grid, Typography, Button, TextField, Box } from "@mui/material";
//API Route
import { Route } from "../../utils/config";
//Animation
import { motion } from "framer-motion";
//Context
import { userContext } from "../../Context";
import { useContext } from "react";
import "./styles.css";
import { useSnackbar } from "notistack";


export default function Claim() {
  const { id } = useParams();
  const [form, setForm] = useState({
    projectId: "",
    partnerId: "",
    startDate: "",
    notes: "",
    submitted: false,
  });

  const { enqueueSnackbar } = useSnackbar();

  const { user } = useContext(userContext);

  const [project, setProject] = useState({
    project: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const getProject = (id) => {
    axios
      .get(`${Route}/Projects/GetProjectDisplayView`, {
        params: {
          projectId: id,
        },
      })
      .then((res) => {
        setProject(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        throw err;
      });
  };

  useEffect(() => {
    getProject(id);
    window.scrollTo(0, 0);
  }, [id]);

  console.log(user, project);

  const handleSubmit = (form) => {
    let store = JSON.parse(localStorage.getItem("login"));
    axios
      .put(`${Route}/Projects/ClaimProject`, {
          "projectId": id,
          "partnerId": user.partnerId.toString(),
          "startDate": form.startDate,
          "notes": form.notes,
        }, {
          headers: {
            Authorization: `Bearer ${store.token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
      .then((res) => {
        setForm({ ...form, "submitted": true });
      })
      .catch((err) => {
        enqueueSnackbar("There was a problem processing this request. Error: "+err.message, { variant: "error" });
        setForm({ ...form, "submitted": false });
        throw err;
      });
  };
  const handleInputChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="claim-page">
        <div className="claim-page-left">
          <Box
            component="form"
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit(form);
            }}
          >
            {form.submitted === true ? (
              <Grid container xs={12} spacing={3} p={6}>
                <Grid item xs={12}>
                  <Typography variant="h4" color="#052442">
                  Thank you for your interest! Your request is being processed. You will be notified when processing is complete.  
                  </Typography>
                </Grid>
              </Grid>) : (
            <Grid container xs={12} spacing={3} p={6}>
              <Grid item xs={12}>
                <Typography variant="h4" color="#052442">
                  Creating a request to claim a project
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body" color="black">
                  Thanks for your interest in working on this project. Please fill out the information below and someone will get back with you.
                </Typography>
              </Grid>
              {/* <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  label="Company Name"
                  name="companyName"
                  value={form.companyName}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  label="Project Name or #"
                  name="projectName"
                  value={form.projectName}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  required
                  label="First Name"
                  name="firstName"
                  value={form.firstName}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  required
                  label="Last Name"
                  name="lastName"
                  value={form.lastName}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  required
                  label="Email"
                  name="email"
                  value={form.email}
                  onChange={handleInputChange}
                />
              </Grid> */}
              {/* <Grid item xs={6}>
                <TextField
                  fullWidth
                  required
                  label="Cell Number"
                  name="phoneNumber"
                  value={form.phoneNumber}
                  onChange={handleInputChange}
                />
              </Grid> */}
              <Grid item xs={12}>
                <TextField
                  InputLabelProps={{ shrink: false }}
                  fullWidth
                  type="date"
                  helperText="When can you begin operations?"
                  name="beginOperation"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Notes"
                  helperText="Please add any information that will help us evaluate your request."
                  name="provideInfo"
                  value={form.provideInfo}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12}>
                <Button variant="contained" size="small" type="submit">
                  Claim this project
                </Button>
              </Grid>
            </Grid>
            )}
          </Box>
        </div>
        <div className="claim-page-right"></div>
      </div>
    </motion.div>
  );
}
